module.exports = __webpack_public_path__ + "img/tsl.eb5fa4d6.jpg";